/**
 * @generated SignedSource<<55c6a9347fc2e0067ddda6db03da9182>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type annotationUpdateAnnotationMutation$variables = {
  annotationCategoryId?: string | null;
  annotationId: string;
  description?: string | null;
  mediaGeojson?: any | null;
};
export type annotationUpdateAnnotationMutation$data = {
  readonly updateAnnotation: {
    readonly annotation: {
      readonly annotationCategory: {
        readonly id: string;
        readonly name: string;
        readonly uuid: string;
      } | null;
      readonly description: string | null;
      readonly id: string;
      readonly mediaGeojson: any | null;
      readonly uuid: string;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type annotationUpdateAnnotationMutation = {
  response: annotationUpdateAnnotationMutation$data;
  variables: annotationUpdateAnnotationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "annotationCategoryId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "annotationId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mediaGeojson"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "annotationCategoryId",
        "variableName": "annotationCategoryId"
      },
      {
        "kind": "Variable",
        "name": "description",
        "variableName": "description"
      },
      {
        "kind": "Variable",
        "name": "mediaGeojson",
        "variableName": "mediaGeojson"
      },
      {
        "kind": "Variable",
        "name": "nodeId",
        "variableName": "annotationId"
      }
    ],
    "concreteType": "UpdateAnnotation",
    "kind": "LinkedField",
    "name": "updateAnnotation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Annotation",
        "kind": "LinkedField",
        "name": "annotation",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AnnotationCategory",
            "kind": "LinkedField",
            "name": "annotationCategory",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mediaGeojson",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "annotationUpdateAnnotationMutation",
    "selections": (v6/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "annotationUpdateAnnotationMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "a3223d1b48110b1eb012f40bccc49183",
    "id": null,
    "metadata": {},
    "name": "annotationUpdateAnnotationMutation",
    "operationKind": "mutation",
    "text": "mutation annotationUpdateAnnotationMutation(\n  $annotationId: ID!\n  $description: String\n  $annotationCategoryId: String\n  $mediaGeojson: GeoJSON\n) {\n  updateAnnotation(description: $description, annotationCategoryId: $annotationCategoryId, nodeId: $annotationId, mediaGeojson: $mediaGeojson) {\n    annotation {\n      id\n      uuid\n      description\n      annotationCategory {\n        uuid\n        id\n        name\n      }\n      mediaGeojson\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "c0ccef7cba789b6eb8c55c82b5368930";

export default node;
